import React, { useEffect, useState } from "react";
import api from "../utils/axios";
import { useAuth } from "../contexts/AuthContext";
import { useParams } from "react-router-dom";
import { Label } from "../components/ui/label";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { Card } from "../components/ui/card";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../components/ui/select";
import { useToast } from "../components/ui/use-toast";

export default function VehicleDetailsPage() {
  const { id: vehicleId } = useParams();
  const [vehicle, setVehicle] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [logs, setLogs] = useState([]);
  const [projects, setProjects] = useState([]);
  const { toast } = useToast();
  const { isAuthenticated, user } = useAuth();
  

  
  const [editMode, setEditMode] = useState(false);
  const [deploymentRecords, setDeploymentRecords] = useState([]);
  const [newRecord, setNewRecord] = useState({ project: "", date_in: "", date_out: "", remarks: "" });
  const [hasInsurance, setHasInsurance] = useState(!!vehicle?.insurance);
  const [hasRoadtax, setHasRoadtax] = useState(!!vehicle?.roadtax);
  const [hasInspection, setHasInspection] = useState(!!vehicle?.inspection);
  const [hasPermitBrunei, setHasPermitBrunei] = useState(!!vehicle?.permit_brunei);
  const [hasPermitSabah, setHasPermitSabah] = useState(!!vehicle?.permit_sabah);
  const [hasPermitSarawak, setHasPermitSarawak] = useState(!!vehicle?.permit_sarawak);

  const [permitBrunei, setPermitBrunei] = useState(vehicle?.permit_brunei || {});
  const [permitSabah, setPermitSabah] = useState(vehicle?.permit_sabah || {});
  const [permitSarawak, setPermitSarawak] = useState(vehicle?.permit_sarawak || {});
  const getPermit = (type) => {
    return vehicle?.permits?.find((p) => p.permit_type === type) || null;
  };
  function DocumentEditor({ label, data, onUpdate, hasRef = false }) {
    const [editing, setEditing] = useState(false);
    const [localData, setLocalData] = useState({ expiry_date: "", license_number: "" });

    useEffect(() => {
      setLocalData({
        expiry_date: data?.expiry_date || "",
        license_number: data?.license_number || "",
      });
    }, [data]);

    const handleSave = async () => {
      const endpointMap = {
        Insurance: "insurances",
        Roadtax: "roadtaxes",
        Inspection: "inspections",
        "Brunei Permit": "permits",
        "Sabah Permit": "permits",
        "Sarawak Permit": "permits",
      };
      const endpoint = endpointMap[label];
      const payload = {
        expiry_date: localData.expiry_date || null,
        vehicle: vehicleId,
        ...(hasRef
            ? {
              license_number: localData.license_number || "",
              permit_type: label.split(" ")[0].toLowerCase(),
            }
            : {}),
      };

      try {
        if (label.includes("Permit")) {
          const check = await api.get(
              `/api/permits/?vehicle=${vehicleId}&permit_type=${payload.permit_type}`
          );
          if (check.data.length > 0) {
            const permitId = check.data[0].id;
            await api.put(`/api/permits/${permitId}/`, payload);
          } else {
            await api.post(`/api/permits/`, payload);
          }
        } else {
          if (data?.id) {
            await api.put(`/api/${endpoint}/${data.id}/`, payload);
          } else {
            await api.post(`/api/${endpoint}/`, payload);
          }
        }

        toast({
          title: "Success",
          description: `${label} saved successfully`,
        });
        setEditing(false);
        
        // Refresh the data by calling onUpdate
        if (onUpdate) {
          onUpdate();
        }
      } catch (err) {
        console.error("Save failed:", err.response?.data || err);
        const errorMessage = err.response?.data?.message || err.response?.data?.error || `Failed to save ${label}`;
        toast({
          title: "Error",
          description: errorMessage,
          variant: "destructive",
        });
      }
    };
    const handleCancel = () => {
      setLocalData({
        expiry_date: data?.expiry_date || "",
        license_number: data?.license_number || "",
      });
      setEditing(false);
    };

    const handleRemove = async () => {
      if (!data?.id) return;
      try {
        const endpointMap = {
          Insurance: "insurances",
          Roadtax: "roadtaxes",
          Inspection: "inspections",
        };
        const endpoint = endpointMap[label];
        if (endpoint) {
          await api.delete(`/api/${endpoint}/${data.id}/`);
          toast({
            title: "Success",
            description: `${label} removed.`,
          });
          onUpdate();
        }
      } catch (err) {
        console.error(err);
        const errorMessage = err.response?.data?.message || err.response?.data?.error || `Failed to remove ${label}`;
        toast({
          title: "Error",
          description: errorMessage,
          variant: "destructive",
        });
      }
    };


    return (
      <div className="space-y-1">
        <Label>{label}</Label>
        <div className="flex items-center gap-4 mt-1">
          <span>{data?.expiry_date || "—"}</span>
          {!editing ? (
              <Button variant="outline" size="sm" onClick={() => setEditing(true)}>
                Update
              </Button>
          ) : (
              <div className="flex gap-2">
                <Button size="sm" className="bg-green-600 text-white" onClick={handleSave}>Save</Button>
                <Button variant="outline" size="sm" onClick={handleCancel}>Cancel</Button>
                {data?.id && (
                    <Button className="bg-red-600 text-white" size="sm" onClick={handleRemove}>
                      Remove
                    </Button>
                )}
              </div>
          )}
        </div>

        {editing && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
              <Input
                  type="date"
                  value={localData.expiry_date}
                  onChange={(e) =>
                      setLocalData((prev) => ({ ...prev, expiry_date: e.target.value }))
                  }
              />
              {hasRef && (
                  <Input
                      placeholder="Reference Number"
                      value={localData.license_number}
                      onChange={(e) =>
                          setLocalData((prev) => ({ ...prev, license_number: e.target.value }))
                      }
                  />
              )}
            </div>
        )}
      </div>
  );
}

const [adding, setAdding] = useState(false);
const [editIndex, setEditIndex] = useState(null);
const [uploadFile, setUploadFile] = useState(null);
const formatStatus = (text) => {
  return text
      .replaceAll("_", " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
};

    useEffect(() => {
    if (!vehicleId || !isAuthenticated) {
      return;
    }

    api.get(`/api/vehicles/${vehicleId}/`)
        .then(res => setVehicle(res.data));

    api.get(`/api/vehicle-documents/?vehicle=${vehicleId}`)
        .then(res => setDocuments(res.data));

    api.get(`/api/vehicle-history/?vehicle_id=${vehicleId}`)
        .then(res => setLogs(res.data));

    api.get(`/api/projects/`)
        .then(res => setProjects(res.data));

    api.get(`/api/deployments/?vehicle_id=${vehicleId}`)
        .then(res => {
          const sorted = res.data.sort((a, b) => new Date(b.date_in) - new Date(a.date_in));
          setDeploymentRecords(sorted);
        });
  }, [vehicleId, isAuthenticated]);

  // Function to refresh vehicle data from backend
  const refreshVehicleData = async () => {
    try {
      const res = await api.get(`/api/vehicles/${vehicleId}/`);
      setVehicle(res.data);
    } catch (err) {
      console.error("Failed to refresh vehicle data:", err);
    }
  };

const updateDeploymentRecord = (index, updatedRecord) => {
  setDeploymentRecords((prev) => {
    const copy = [...prev];
    copy[index] = updatedRecord;
    return copy;
  });
};

  const saveDeploymentRecord = async (record, index) => {
    try {
      // Use the current state instead of the passed record
      const currentRecord = deploymentRecords[index];
      const updateData = {
        vehicle: vehicleId,  // Add vehicle field - required by backend
        project: currentRecord.project,
        date_in: currentRecord.date_in,
        date_out: currentRecord.date_out,
        remarks: currentRecord.remarks,
      };
      
      const res = await api.put(
          `/api/deployments/${record.id}/`,
          updateData
      );

      setDeploymentRecords((prev) => {
        const copy = [...prev];
        copy[index] = res.data;
        return copy;
      });

      toast({
        title: "Success",
        description: "Deployment updated.",
      });
      
      // Exit edit mode after successful save
      setEditIndex(null);
    } catch (err) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.response?.data?.error || "Failed to save deployment.";
      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
    }
  };


  const handleAddDeploymentRecord = () => {
    api.post(
        `/api/deployments/`,
        {
          vehicle: vehicleId,
          project: newRecord.project,
          date_in: newRecord.date_in,
          date_out: newRecord.date_out,
          remarks: newRecord.remarks,
        }
    ).then(res => {
      setDeploymentRecords((prev) => [...prev, res.data]);
      setAdding(false);
      setNewRecord({ project: "", date_in: "", date_out: "", remarks: "" });
    }).catch(err => {
      const errorMessage = err.response?.data?.message || err.response?.data?.error || "Failed to save deployment record.";
      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
    });
  };

  const handleUpload = () => {
    if (!uploadFile) return;
    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("vehicle_id", vehicleId);

    api.post(
        `/api/vehicle-documents/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
    ).then(res => {
      setDocuments(prev => [...prev, res.data]);
      setUploadFile(null);
    }).catch(err => {
      console.error("Upload failed:", err.response?.data || err);
      let errorMessage = "Failed to upload document.";
      
      // Check for new error structure from custom exception handler
      if (err.response?.data?.details) {
        // Handle field-specific validation errors from custom handler
        const details = err.response.data.details;
        const fieldErrors = [];
        
        for (const [field, errors] of Object.entries(details)) {
          if (Array.isArray(errors)) {
            const fieldLabel = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            fieldErrors.push(`${fieldLabel}: ${errors.join(', ')}`);
          }
        }
        
        if (fieldErrors.length > 0) {
          errorMessage = `Please fix the following errors:\n${fieldErrors.join('\n')}`;
        } else {
          errorMessage = err.response.data.message || "Validation failed";
        }
      }
      // Check for DRF validation errors (direct field errors)
      else if (err.response?.data && typeof err.response.data === 'object') {
        const fieldErrors = [];
        
        // Check if response.data contains field names as keys
        for (const [field, errors] of Object.entries(err.response.data)) {
          if (Array.isArray(errors) && field !== 'error' && field !== 'message' && field !== 'details') {
            const fieldLabel = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            fieldErrors.push(`${fieldLabel}: ${errors.join(', ')}`);
          }
        }
        
        if (fieldErrors.length > 0) {
          errorMessage = `Please fix the following errors:\n${fieldErrors.join('\n')}`;
        } else {
          errorMessage = err.response.data.message || err.response.data.error || "Validation failed";
        }
      }
      // Keep existing checks for backward compatibility
      else if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.response?.data?.error) {
        errorMessage = err.response.data.error;
      }
      
      toast({
        title: "Document Upload Failed",
        description: errorMessage,
        variant: "destructive",
      });
    });
  };


  const handleDelete = (docId) => {
    api.delete(
        `/api/vehicle-documents/${docId}/`
    ).then(() => {
      setDocuments(prev => prev.filter(d => d.id !== docId));
    }).catch(err => {
      const errorMessage = err.response?.data?.message || err.response?.data?.error || "Failed to delete document.";
      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
    });
  };

  const handleDownload = async (docId, filename) => {
    try {
      const response = await api.get(`/api/vehicle-documents/${docId}/download/`, {
        responseType: 'blob'
      });
      
      // Create a blob URL and trigger download
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      toast({
        title: "Success",
        description: "Document downloaded successfully.",
      });
    } catch (err) {
      const errorMessage = err.response?.data?.error || "Failed to download document.";
      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
    }
  };


  const handleDeleteDeploymentRecord = (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    api.delete(
        `/api/deployments/${id}/`
    )
        .then(() => {
          setDeploymentRecords((prev) => prev.filter((r) => r.id !== id));
          toast({
            title: "Success",
            description: "Deployment record deleted.",
          });
        })
        .catch(err => {
          const errorMessage = err.response?.data?.message || err.response?.data?.error || "Failed to delete record.";
          toast({
            title: "Error",
            description: errorMessage,
            variant: "destructive",
          });
        });
  };

  const handleSave = () => {
    // Client-side validation for field lengths
    const fieldLengths = {
      manufacturer: 50,
      model: 50,
      year_of_manufacture: 30,
      machinery_no: 50,
      bdm: 10,
      btm: 10,
      bg2: 10
    };

    const errors = [];
    
    // Check field lengths
    Object.entries(fieldLengths).forEach(([field, maxLength]) => {
      if (vehicle[field] && vehicle[field].length > maxLength) {
        errors.push(`${field.replace(/_/g, ' ')} is too long (max ${maxLength} characters)`);
      }
    });

    if (errors.length > 0) {
      toast({
        title: "Validation Error",
        description: errors.join(', '),
        variant: "destructive",
      });
      return;
    }



    if (!isAuthenticated) {
      toast({
        title: "Authentication Error",
        description: "You must be logged in to access this feature.",
        variant: "destructive",
      });
      return;
    }

    const payload = {
      plate_number: vehicle.plate_number,
      car_type: vehicle.car_type,
      manufacturer: vehicle.manufacturer || null,
      model: vehicle.model || null,
      year_of_manufacture: vehicle.year_of_manufacture || null,
      company_name: vehicle.company_name,
      status: vehicle.status,
      engine_chassis: vehicle.engine_chassis || null,
      machinery_no: vehicle.machinery_no || null,
      bdm: vehicle.bdm || null,
      btm: vehicle.btm || null,
      bg2: vehicle.bg2 || null,
      road_status: vehicle.road_status || null,
      project_id: vehicle.project?.id || vehicle.project || null,  // vehicle.project is already the ID when editing
    };

    

    api
      .put(`/api/vehicles/${vehicleId}/`, payload)
              .then((response) => {
        setEditMode(false);
        toast({
          title: "Success",
          description: "Vehicle details saved.",
        });
      })
      .catch((error) => {
        console.error("Save error:", error.response?.data || error);
        let errorMessage = "Failed to save changes.";
        
        // Check for new error structure from custom exception handler
        if (error.response?.data?.details) {
          // Handle field-specific validation errors from custom handler
          const details = error.response.data.details;
          const fieldErrors = [];
          
          // Map field names to user-friendly names
          const fieldLabels = {
            'plate_number': 'Plate Number',
            'car_type': 'Car Type',
            'company_name': 'Company Name',
            'status': 'Status',
            'year_of_manufacture': 'Year of Manufacture',
            'engine_chassis': 'Engine/Chassis Number',
            'machinery_no': 'Machinery Number',
            'bdm': 'BDM',
            'btm': 'BTM',
            'bg2': 'BG2',
            'manufacturer': 'Manufacturer',
            'model': 'Model',
            'road_status': 'Road Status',
            'project_id': 'Project'
          };
          
          for (const [field, errors] of Object.entries(details)) {
            if (Array.isArray(errors)) {
              const fieldLabel = fieldLabels[field] || field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
              fieldErrors.push(`${fieldLabel}: ${errors.join(', ')}`);
            }
          }
          
          if (fieldErrors.length > 0) {
            errorMessage = `Please fix the following errors:\n${fieldErrors.join('\n')}`;
          } else {
            errorMessage = error.response.data.message || "Validation failed";
          }
        }
        // Check for DRF validation errors (direct field errors)
        else if (error.response?.data && typeof error.response.data === 'object') {
          const fieldErrors = [];
          
          // Check if response.data contains field names as keys
          for (const [field, errors] of Object.entries(error.response.data)) {
            if (Array.isArray(errors) && field !== 'error' && field !== 'message' && field !== 'details') {
              const fieldLabels = {
                'plate_number': 'Plate Number',
                'car_type': 'Car Type',
                'company_name': 'Company Name',
                'status': 'Status',
                'year_of_manufacture': 'Year of Manufacture',
                'engine_chassis': 'Engine/Chassis Number',
                'machinery_no': 'Machinery Number',
                'bdm': 'BDM',
                'btm': 'BTM',
                'bg2': 'BG2',
                'manufacturer': 'Manufacturer',
                'model': 'Model',
                'road_status': 'Road Status',
                'project_id': 'Project'
              };
              
              const fieldLabel = fieldLabels[field] || field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
              fieldErrors.push(`${fieldLabel}: ${errors.join(', ')}`);
            }
          }
          
          if (fieldErrors.length > 0) {
            errorMessage = `Please fix the following errors:\n${fieldErrors.join('\n')}`;
          } else {
            errorMessage = error.response.data.message || error.response.data.error || "Validation failed";
          }
        }
        // Keep existing checks for backward compatibility
        else if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response?.data?.error) {
          errorMessage = error.response.data.error;
        }
        
        toast({
          title: "Error",
          description: errorMessage,
          variant: "destructive",
        });
      });
  };

const formatValue = (val) => {
    if (!val) return val;
    return val
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase())
        .replace(/\bKh\b/g, "KH") // Convert "Kh" to "KH"
        .replace(/\bAm\b/g, "AM"); // Convert "Am" to "AM"
};

  const getCharacterCountDisplay = (text, maxLength) => {
    const currentLength = text?.length || 0;
    const remaining = maxLength - currentLength;
    
    let colorClass = 'text-gray-500';
    if (remaining <= 5) {
      colorClass = 'text-red-500';
    } else if (remaining <= 10) {
      colorClass = 'text-yellow-500';
    } else if (remaining <= 20) {
      colorClass = 'text-green-500';
    }
    
    return (
      <div className={`text-xs mt-1 ${colorClass}`}>
        {currentLength}/{maxLength} characters
        {remaining <= 2 && <span className="ml-2 font-semibold">⚠️ Approaching limit!</span>}
      </div>
    );
  };

return (
    <div className="max-w-5xl mx-auto py-6 px-4">
      <h1 className="text-2xl font-bold mb-4">
        Vehicle Details{vehicle?.plate_number ? ` – ${vehicle.plate_number}` : ""}
      </h1>


      <Tabs defaultValue="info" className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="info">🚗 Info</TabsTrigger>
          <TabsTrigger value="documents">📎 Documents</TabsTrigger>
          <TabsTrigger value="logs">📜 History Logs</TabsTrigger>
          <TabsTrigger value="deployment">🏗️ Deployment Record</TabsTrigger>
        </TabsList>

        <TabsContent value="info">
          {vehicle ? (
              <Card className="p-4 space-y-4">
                <h2 className="text-xl font-semibold">🚗 Vehicle Info</h2>

                <div className="flex justify-end gap-2">
                  {editMode && <Button className="bg-green-600 text-white"onClick={handleSave}>Save</Button>}
                  <Button variant="outline" onClick={() => setEditMode((prev) => !prev)}>
                    {editMode ? "Cancel" : "Edit"}
                  </Button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Plate Number (not editable) */}
                  <div>
                    <Label>Plate Number</Label>
                    <Input value={vehicle.plate_number || ""} disabled />
                  </div>

                  {/* Vehicle Type (editable) */}
                  <div>
                    <Label>Vehicle Type</Label>
                    {!editMode ? (
                        <Input value={formatValue(vehicle.car_type)} disabled />
                    ) : (
                        <Select value={vehicle.car_type} onValueChange={(value) => setVehicle((prev) => ({ ...prev, car_type: value }))}>
                          <SelectTrigger><SelectValue placeholder="Select Vehicle Type" /></SelectTrigger>
                          <SelectContent>
                            {["barge", "backhoe_loader", "bulldozer", "company_car", "cement_truck", "excavator", "forklift", "grader", "jeep", "machinery", "mobile_crane", "motorcar", "motorcycle", "pick_up", "prime_mover", "rigid_diesel_tank_lorry", "rigid_lorry", "rigid_lorry_10_wheels", "rigid_lorry_6_wheels", "rigid_lorry_cargo_am", "rigid_lorry_cargo_am_with_crane", "rigid_lorry_vehicle_carrier", "road_paver", "road_roller", "semi_trailer_bitumen_tanker", "semi_trailer_low_loader", "shovel", "tractor", "trailer", "tugboat", "window_van"].sort().map((type) => (
                                <SelectItem key={type} value={type}>{type.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()).replace(/\bAm\b/g, "AM")}</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                    )}
                  </div>

                  <div>
                    <Label>Manufacturer</Label>
                    <Input
                        disabled={!editMode}
                        value={vehicle.manufacturer || ""}
                        onChange={(e) =>
                            setVehicle((prev) => ({ ...prev, manufacturer: e.target.value }))
                        }
                        maxLength={50}
                    />
                    {getCharacterCountDisplay(vehicle.manufacturer, 50)}
                  </div>

                  <div>
                    <Label>Model</Label>
                    <Input
                        disabled={!editMode}
                        value={vehicle.model || ""}
                        onChange={(e) =>
                            setVehicle((prev) => ({ ...prev, model: e.target.value }))
                        }
                        maxLength={50}
                    />
                    {getCharacterCountDisplay(vehicle.model, 50)}
                  </div>

                  <div>
                    <Label>Year of Manufacture</Label>
                    <Input
                        disabled={!editMode}
                        value={vehicle.year_of_manufacture || ""}
                        onChange={(e) =>
                            setVehicle((prev) => ({
                              ...prev,
                              year_of_manufacture: e.target.value,
                            }))
                        }
                        maxLength={30}
                    />
                    {getCharacterCountDisplay(vehicle.year_of_manufacture, 30)}
                  </div>

                  <div>
                    <Label>Engine / Chassis</Label>
                    <Input
                        disabled={!editMode}
                        value={vehicle.engine_chassis || ""}
                        onChange={(e) =>
                            setVehicle((prev) => ({
                              ...prev,
                              engine_chassis: e.target.value,
                            }))
                        }
                    />
                    {getCharacterCountDisplay(vehicle.engine_chassis, 255)}
                  </div>

                  <div>
                    <Label>Machinery No.</Label>
                    <Input
                        disabled={!editMode}
                        value={vehicle.machinery_no || ""}
                        onChange={(e) =>
                            setVehicle((prev) => ({
                              ...prev,
                              machinery_no: e.target.value,
                            }))
                        }
                        maxLength={50}
                    />
                    {getCharacterCountDisplay(vehicle.machinery_no, 50)}
                  </div>

                  <div>
                    <Label>BDM</Label>
                    <Input
                        disabled={!editMode}
                        value={vehicle.bdm || ""}
                        onChange={(e) =>
                            setVehicle((prev) => ({ ...prev, bdm: e.target.value }))
                        }
                        maxLength={10}
                    />
                    {getCharacterCountDisplay(vehicle.bdm, 10)}
                  </div>

                  <div>
                    <Label>BTM</Label>
                    <Input
                        disabled={!editMode}
                        value={vehicle.btm || ""}
                        onChange={(e) =>
                            setVehicle((prev) => ({ ...prev, btm: e.target.value }))
                        }
                        maxLength={10}
                    />
                    {getCharacterCountDisplay(vehicle.btm, 10)}
                  </div>

                  <div>
                    <Label>BG2</Label>
                    <Input
                        disabled={!editMode}
                        value={vehicle.bg2 || ""}
                        onChange={(e) =>
                            setVehicle((prev) => ({ ...prev, bg2: e.target.value }))
                        }
                        maxLength={10}
                    />
                    {getCharacterCountDisplay(vehicle.bg2, 10)}
                  </div>

                  <div>
                    <Label>Road Status</Label>
                    {editMode ? (
                        <Select
                            value={vehicle.road_status || ""}
                            onValueChange={(val) =>
                                setVehicle((prev) => ({ ...prev, road_status: val }))
                            }
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Select" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="on_road">On Road</SelectItem>
                            <SelectItem value="off_road">Off Road</SelectItem>
                          </SelectContent>
                        </Select>
                    ) : (
                        <Input disabled value={formatValue(vehicle.road_status)} />
                    )}
                  </div>

                  <div>
                    <Label>Status</Label>
                    {editMode ? (
                        <Select
                            value={vehicle.status || ""}
                            onValueChange={(val) =>
                                setVehicle((prev) => ({ ...prev, status: val }))
                            }
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Select status" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="in_use">In Use</SelectItem>
                            <SelectItem value="in_maintenance">In Maintenance</SelectItem>
                            <SelectItem value="available">Available</SelectItem>
                            <SelectItem value="no_longer_available">
                              No Longer Available
                            </SelectItem>
                          </SelectContent>
                        </Select>
                    ) : (
                        <Input disabled value={formatValue(vehicle.status)} />
                    )}
                  </div>

                  <div>
                    <Label>Company</Label>
                    {editMode ? (
                        <Select
                            value={vehicle.company_name || ""}
                            onValueChange={(val) =>
                                setVehicle((prev) => ({ ...prev, company_name: val }))
                            }
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Select company" />
                          </SelectTrigger>
                          <SelectContent>
                            {[
                              "kemena_holding_sdn_bhd",
                              "eastern_park_sdn_bhd",
                              "kenygold_resources_sdn_bhd",
                              "kenygold_sdn_bhd",
                              "kenygold_trading_sdn_bhd",
                              "jayhong_sdn_bhd",
                              "hi_rich_trading_sdn_bhd",
                              "palmjaya_sdn_bhd",
                              "hap_jet_galvanized_sdn_bhd",
                              "kemena_hotel",
                              "bandar_sinar_sdn_bhd",
                              "eastern_roadworks_sdn_bhd",
                              "kemena_energy_sdn_bhd",
                              "metro_mekar_sdn_bhd",
                              "pelita_raya_sdn_bhd",
                              "kh_premix_sdn_bhd",
                              "kh_industry_sdn_bhd",
                              "bestone_quarry_sdn_bhd",
                            ].sort().map((c) => (
                                <SelectItem key={c} value={c}>
                                  {c.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                                </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                    ) : (
                        <Input disabled value={formatValue(vehicle.company_name)} />
                    )}
                  </div>

                  <div className="md:col-span-2">
                    <Label>Deployment</Label>
                    {editMode ? (
                        <Select
                            value={
                                vehicle?.project?.id?.toString() ||
                                vehicle?.project?.toString() ||
                                ""
                            }
                            onValueChange={(val) => {
                                const projectId = val ? parseInt(val) : null;
                                setVehicle((prev) => ({
                                  ...prev,
                                  project: projectId,
                                }));
                            }}
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Select Deployment" />
                          </SelectTrigger>
                          <SelectContent>
                            {projects.map((proj) => (
                                <SelectItem key={proj.id} value={proj.id.toString()}>
                                  {proj.name}
                                </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                    ) : (
                        <Input
                            disabled
                            value={
                                projects.find(
                                    (p) => p.id === (vehicle?.project?.id || vehicle?.project)
                                )?.name || "-"
                            }
                        />
                    )}
                  </div>
                </div>

                {/* Document Switches */}
                <div className="space-y-6 pt-6">
                  <DocumentEditor
                      label="Insurance"
                      data={vehicle?.insurance}
                      onUpdate={refreshVehicleData}
                  />
                  <DocumentEditor
                      label="Roadtax"
                      data={vehicle?.roadtax}
                      onUpdate={refreshVehicleData}
                  />
                  <DocumentEditor
                      label="Inspection"
                      data={vehicle?.inspection}
                      onUpdate={refreshVehicleData}
                  />
                  {/* ✅ fixed permit handling */}
                  <DocumentEditor
                      label="Brunei Permit"
                      data={getPermit("brunei")}
                      hasRef
                      onUpdate={refreshVehicleData}
                  />
                  <DocumentEditor
                      label="Sabah Permit"
                      data={getPermit("sabah")}
                      hasRef
                      onUpdate={refreshVehicleData}
                  />
                  <DocumentEditor
                      label="Sarawak Permit"
                      data={getPermit("sarawak")}
                      hasRef
                      onUpdate={refreshVehicleData}
                  />
                </div>
              </Card>
          ) : (
              <p>Loading vehicle...</p>
          )}
        </TabsContent>



        <TabsContent value="documents">
          <div className="space-y-4">
            <Label>Upload Document</Label>
            <div className="flex items-center gap-2">
              <Input type="file" onChange={(e) => setUploadFile(e.target.files[0])} />
              <Button onClick={handleUpload}>Upload</Button>
            </div>

            <Label>Uploaded Files</Label>
            <ul className="text-sm list-disc list-inside text-muted-foreground space-y-1">
              {documents.map((doc) => (
                <li key={doc.id} className="flex items-center gap-2">
                  {doc.file.split("/").pop()}
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => handleDownload(doc.id, doc.file.split("/").pop())}
                    className="text-blue-600"
                  >
                    Download
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => handleDelete(doc.id)}
                  >
                    Delete
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </TabsContent>

         <TabsContent value="logs">
  <Card className="p-4">
    <h3 className="text-lg font-bold mb-2">Change Logs</h3>
    {logs.length === 0 ? (
      <p className="text-muted-foreground italic">No logs found.</p>
    ) : (
      Object.entries(
        logs
          .filter(log => {
            if (log.history_type === "+" || log.history_type === "-") return true;
            if (
              Array.isArray(log.changes) &&
              log.changes.length === 1 &&
              log.changes[0] === "No relevant field changes."
            ) {
              return false;
            }
            return Array.isArray(log.changes) && log.changes.length > 0;
          })
          .sort((a, b) => new Date(b.history_date) - new Date(a.history_date))
          .reduce((grouped, log) => {
            const date = new Date(log.history_date).toLocaleDateString("en-GB", {
              year: "numeric",
              month: "long",
              day: "numeric",
            });
            if (!grouped[date]) grouped[date] = [];
            grouped[date].push(log);
            return grouped;
          }, {})
      ).map(([date, logsOnDate], idx) => (
        <div key={idx} className="mb-4">
          <h4 className="font-semibold text-md mb-2">{date}</h4>
          {logsOnDate.map((log, i) => {
            const time = new Date(log.history_date).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            });
            const user = log.history_user || "System";
            const plate = log.plate_number;
            let emoji = "✏️";
            let message = "";

            if (log.history_type === "+") {
              emoji = "🚗";
              message = `(A new vehicle ${plate} was added)`;
            } else if (log.history_type === "-") {
              emoji = "🗑️";
              message = `(Vehicle ${plate} was removed from the list)`;
            } else {
              const formattedChanges = log.changes.map((change) => {
                if (change.startsWith("Status changed from '")) {
                  return change.replace(
                    /Status changed from '(.+?)' to '(.+?)'/,
                    (_, from, to) =>
                      `Status changed from ${formatStatus(from)} to ${formatStatus(to)}`
                  );
                }
                return change;
              });
              message = `(${formattedChanges.join(", ")})`;
            }

return (
  <div key={i} className="text-sm mb-2">
    <div className="pl-2 flex gap-2">
      <span className="font-mono">{time}</span>
      <span>
        {plate}, {user} →
      </span>
    </div>
    {log.history_type === "+" || log.history_type === "-" ? (
      <div className="pl-10 flex gap-2">
        <span className="w-6">{emoji}</span>
        <span>{message}</span>
      </div>
    ) : (
      log.changes
  .filter(change => !change.startsWith("History Type changed from"))
  .map((change, idx) => {
        let formatted = change;
        if (change.startsWith("Status changed from '")) {
  formatted = change.replace(
    /Status changed from '(.+?)' to '(.+?)'/,
    (_, from, to) =>
      `Status changed from ${formatStatus(from)} to ${formatStatus(to)}`
  );
} else if (change.startsWith("Company Name changed from '")) {
  formatted = change.replace(
    /Company Name changed from '(.+?)' to '(.+?)'/,
    (_, from, to) =>
      `Company Name changed from ${formatStatus(from)} to ${formatStatus(to)}`
  );
}
        return (
          <div key={idx} className="pl-10 flex gap-2">
            <span className="w-6">✏️</span>
            <span>{formatted}</span>
          </div>
        );
      })
    )}
  </div>
);
          })}
        </div>
      ))
    )}
  </Card>
</TabsContent>

        <TabsContent value="deployment">
          <Card className="p-4 space-y-4">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-bold">Deployment Records</h3>
              <Button onClick={() => setAdding(true)}>➕ Add Record</Button>
            </div>

            {adding && (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-muted p-4 rounded-lg">
                  <div>
                    <Label>Project</Label>
                    <Select
                        value={newRecord.project || ""}
                        onValueChange={(val) =>
                            setNewRecord((prev) => ({ ...prev, project: val }))
                        }
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Select Project" />
                      </SelectTrigger>
                      <SelectContent>
                        {projects.map((proj) => (
                            <SelectItem key={proj.id} value={proj.id.toString()}>
                              {proj.name}
                            </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>

                  <div>
                    <Label>Date In</Label>
                    <Input
                        type="date"
                        value={newRecord.date_in}
                        onChange={(e) =>
                            setNewRecord((prev) => ({ ...prev, date_in: e.target.value }))
                        }
                    />
                  </div>

                  <div>
                    <Label>Date Out</Label>
                    <Input
                        type="date"
                        value={newRecord.date_out}
                        onChange={(e) =>
                            setNewRecord((prev) => ({ ...prev, date_out: e.target.value }))
                        }
                    />
                  </div>

                  {/* ✅ Add Remarks field */}
                  <div className="md:col-span-3">
                    <Label>Remarks</Label>
                    <Input
                        value={newRecord.remarks || ""}
                        onChange={(e) =>
                            setNewRecord((prev) => ({ ...prev, remarks: e.target.value }))
                        }
                    />
                  </div>

                  <div className="md:col-span-3 flex justify-end gap-2 mt-2">
                    <Button
                        className="bg-green-600 text-white"
                        onClick={handleAddDeploymentRecord}
                        disabled={!newRecord.project || !newRecord.date_in}
                    >
                      Save
                    </Button>
                    <Button variant="ghost" onClick={() => setAdding(false)}>
                      Cancel
                    </Button>
                  </div>
                </div>
            )}


            {deploymentRecords.length === 0 ? (
                <p className="text-muted-foreground italic">No records found.</p>
            ) : (
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                    <tr className="text-left border-b">
                      <th className="p-2">Project</th>
                      <th className="p-2">Date In</th>
                      <th className="p-2">Date Out</th>
                      <th className="p-2">Remarks</th>
                    </tr>
                    </thead>
                    <tbody>
                    {deploymentRecords.map((record, i) => (
                        <tr key={i} className="border-b hover:bg-muted">
                          <td className="p-2">
                            {editIndex === i ? (
                                <Select
                                    value={record.project?.toString()}
                                    onValueChange={(val) =>
                                        updateDeploymentRecord(i, { ...record, project: parseInt(val) })
                                    }
                                >
                                  <SelectTrigger><SelectValue /></SelectTrigger>
                                  <SelectContent>
                                    {projects.map((proj) => (
                                        <SelectItem key={proj.id} value={proj.id.toString()}>
                                          {proj.name}
                                        </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                            ) : (
                                <span>{projects.find(p => p.id === record.project)?.name || "-"}</span>
                            )}
                          </td>

                          <td className="p-2">
                            {editIndex === i ? (
                                <Input
                                    type="date"
                                    value={record.date_in}
                                    onChange={(e) =>
                                        updateDeploymentRecord(i, { ...record, date_in: e.target.value })
                                    }
                                />
                            ) : (
                                <span>{record.date_in}</span>
                            )}
                          </td>

                          <td className="p-2">
                            {editIndex === i ? (
                                <Input
                                    type="date"
                                    value={record.date_out || ""}
                                    onChange={(e) =>
                                        updateDeploymentRecord(i, { ...record, date_out: e.target.value })
                                    }
                                />
                            ) : (
                                <span>{record.date_out || "-"}</span>
                            )}
                          </td>

                          <td className="p-2">
                            {editIndex === i ? (
                                <Input
                                    value={record.remarks || ""}
                                    onChange={(e) =>
                                        updateDeploymentRecord(i, { ...record, remarks: e.target.value })
                                    }
                                />
                            ) : (
                                <span>{record.remarks || "-"}</span>
                            )}
                          </td>

                          <td className="p-2 flex gap-2">
                            {editIndex === i ? (
                                <>
                                  <Button size="sm" className="bg-green-600 text-white" onClick={() => saveDeploymentRecord(record, i)}>Save</Button>
                                  <Button size="sm" variant="ghost" onClick={() => setEditIndex(null)}>Cancel</Button>
                                </>
                            ) : (
                                <>
                                  <Button size="sm" className="bg-blue-600 text-white" onClick={() => {
                                    
                                    setEditIndex(i);
                                }}>Edit</Button>
                                  <Button
                                      size="sm"
                                      className="bg-red-600 text-white"
                                      onClick={() => handleDeleteDeploymentRecord(record.id)}
                                  >
                                    Delete
                                  </Button>
                                </>
                            )}
                          </td>
                        </tr>
                    ))}

                    </tbody>
                  </table>
                </div>
            )}
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}